export type ExecutionStatus =
  | "queued"
  | "running"
  | "completed"
  | "failed"
  | "cancelled";

export type ConnectionStatus =
  | "connected"
  | "reconnecting"
  | "disconnected";

export type ExecutionSession = {
  executionId: string | null;
  executionStatus: ExecutionStatus | null;
  connectionStatus: ConnectionStatus;
  lastEventId: number;
};

// Initial state for the reducer
export const initialExecutionSession: ExecutionSession = {
  executionId: null,
  executionStatus: null,
  connectionStatus: "disconnected",
  lastEventId: 0,
};
